import { viewEmail as viewEmail_1 } from './LinkedEmailEntity.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react';
import * as React from 'react';

import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./LinkedEmailEntity.scss');

export interface LinkedEmailEntityProps {
    emailId: string;
    onClick: (emailId: string) => void;
}

@observer
export default class LinkedEmailEntity extends React.Component<LinkedEmailEntityProps, {}> {
    render() {
        return (
            <ActionButton
                className={styles.viewEmailButton}
                onClick={this.viewEmail}
                text={loc(viewEmail_1)}
                iconProps={{
                    iconName: ControlIcons.Mail,
                    className: styles.emailIcon,
                }}
            />
        );
    }

    private viewEmail = () => {
        this.props.onClick(this.props.emailId);
    };
}
